export const baseURL = process.env.REACT_APP_URL || 'https://www.drawbackchess.com'
export const shortURL = process.env.REACT_APP_FULL_URL || 'drawbackchess.com'
